<template>
  <v-simple-table dense height="70px">
    <template v-slot:default>
      <tbody>
        <tr>
          <td width="10%">Kota:</td>
          <td class="text-left" width="40%">{{ data.kota || "-" }}</td>
          <td width="10%">Alamat:</td>
          <td class="text-left" width="40%">{{ data.alamat || "-" }}</td>
        </tr>
        <tr></tr>
        <tr>
          <td width="10%">Telp:</td>
          <td class="text-left" width="40%">{{ data.telp || "-" }}</td>
          <td width="10%">Email:</td>
          <td class="text-left" width="40%">{{ data.email || "-" }}</td>
        </tr>
        <tr></tr>
        <tr>
          <td width="10%">Ket:</td>
          <td class="text-left" width="40%" colspan="3">
            {{ data.ket || "-" }}
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: "InfoPenerima",
  props: ["data"]
};
</script>
